import { DocumentModule } from '@app/modules/document/document.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HistoricRoutingModule } from './historic-routing.module';
import { HistoricComponent } from './historic.component';
import { SharedModule } from '@app/shared';
import { NgxLoadingModule } from 'ngx-loading';
import { FormFilterComponent } from './form-filter/form-filter.component';
import { ModalCancelRetentionComponent } from './modal-cancel-retention/modal-cancel-retention.component';
import { ModalSendDocumentComponent } from '../document/pages/modal-send-document/modal-send-document.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [HistoricComponent, FormFilterComponent, ModalCancelRetentionComponent],
  exports: [HistoricComponent, ModalCancelRetentionComponent],
  imports: [
    CommonModule,
    HistoricRoutingModule,
    SharedModule,
    NgxLoadingModule.forRoot({}),
    NgxMaskModule.forRoot(),
    DocumentModule
  ],
  entryComponents: [ModalCancelRetentionComponent, ModalSendDocumentComponent]
})
export class HistoricModule {}
